var PRIMARY_ADDRESS_TOOLTIP = 'Select this check box to make this the default address when searching for nearby programs. ' + 'You can always update which address you’re using while searching.';
export { PRIMARY_ADDRESS_TOOLTIP };
//# sourceMappingURL=constants.js.map